<template>
    <div class="searchSpeed" >
        <div class="speed-item" v-for="(item,index) in washServiceSpeedList" :key="index" @click="onSpeed(item)">
            {{ item.speedName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data(){
        return{
            washServiceSpeedList: [],
        }
    },
    mounted() {
        this.getWashProductBrandList();
    },
    methods:{
        getWashProductBrandList(){
            get("/wash/utils/findAllWashServiceSpeed").then((res)=>{
                if(res.success){
                    this.washServiceSpeedList = res.list
                }
            })
        },

        onSpeed(speedItem){
            this.$emit("onSpeed", speedItem)
        }
    }
}
</script>

<style scoped lang="scss">
.searchSpeed{
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .speed-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }
}
</style>